import type {
  ClaimRelationshipSide,
  ClaimRelationshipType,
  CreateClaimRelationshipInput,
} from '@billing/validation';

export type ClaimRelationshipChoice =
  | 'RELATED'
  | 'CURRENT_SPLIT_FROM_SELECTED'
  | 'SELECTED_SPLIT_FROM_CURRENT'
  | 'CURRENT_COPY_OF_SELECTED'
  | 'SELECTED_COPY_OF_CURRENT';

export const mapClaimRelationshipChoice = ({
  currentClaimID,
  selectedClaimID,
  choice,
}: {
  currentClaimID: string;
  selectedClaimID: string;
  choice: ClaimRelationshipChoice;
}): CreateClaimRelationshipInput => {
  switch (choice) {
    case 'CURRENT_SPLIT_FROM_SELECTED':
      return {
        fromClaimID: selectedClaimID,
        toClaimID: currentClaimID,
        relationshipType: 'SPLIT',
      };
    case 'SELECTED_SPLIT_FROM_CURRENT':
      return {
        fromClaimID: currentClaimID,
        toClaimID: selectedClaimID,
        relationshipType: 'SPLIT',
      };
    case 'CURRENT_COPY_OF_SELECTED':
      return {
        fromClaimID: selectedClaimID,
        toClaimID: currentClaimID,
        relationshipType: 'COPY',
      };
    case 'SELECTED_COPY_OF_CURRENT':
      return {
        fromClaimID: currentClaimID,
        toClaimID: selectedClaimID,
        relationshipType: 'COPY',
      };
    case 'RELATED':
      return {
        fromClaimID: currentClaimID,
        toClaimID: selectedClaimID,
        relationshipType: 'RELATED',
      };
  }
};

export const getClaimRelationshipLabelKey = (
  relationshipType: ClaimRelationshipType,
  currentClaimSide: ClaimRelationshipSide
): 'relatedTo' | 'splitFrom' | 'copiedTo' | 'copyOf' => {
  if (relationshipType === 'RELATED') {
    return 'relatedTo';
  }
  if (relationshipType === 'SPLIT') {
    return 'splitFrom';
  }
  return currentClaimSide === 'FROM' ? 'copiedTo' : 'copyOf';
};

export const getDuplicateSourceClaimID = ({
  sourceClaim,
  patientID,
  siteID,
}: {
  sourceClaim?: {
    id: string;
    patientID: string | null;
    siteID: string;
  } | null;
  patientID: string | null;
  siteID: string;
}): string | undefined => {
  if (
    !sourceClaim?.patientID ||
    sourceClaim.patientID !== patientID ||
    sourceClaim.siteID !== siteID
  ) {
    return undefined;
  }

  return sourceClaim.id;
};
